import { APIResponse, AreaData, FeatureData } from '../../@types';
import { makeAPICall } from './clientHelpers/makeAPICall';

export const dataClient = {
  getAreas: async (
    loadAllAreas?: boolean
  ): Promise<APIResponse<Array<AreaData>>> => {
    const { notModified, data, error } = await makeAPICall({
      method: 'GET',
      url: '/areas',
      params: { loadAllAreas },
    });
    return {
      notModified,
      data,
      error,
    };
  },
  getFeatures: async (internal: boolean): Promise<APIResponse<FeatureData>> => {
    const { notModified, data, error } = await makeAPICall({
      method: 'GET',
      url: '/features',
      params: {
        internal,
      },
    });
    return {
      notModified,
      data,
      error,
    };
  },
};
